import { useEffect, useState } from 'react';
import { fetchBackgroundBySlug } from './backgroundsApi';

export function usePageBackground(pageSlug, defaultImage) {
  const [imageUrl, setImageUrl] = useState(defaultImage);

  useEffect(() => {
    let active = true;
    fetchBackgroundBySlug(pageSlug)
      .then((row) => {
        if (!active) return;
        setImageUrl(row?.image_url || defaultImage);
      })
      .catch(() => {
        if (active) setImageUrl(defaultImage);
      });
    return () => { active = false; };
  }, [pageSlug, defaultImage]);

  return imageUrl;
}

export function toDatetimeLocalValue(isoString) {
  if (!isoString) return '';
  const d = new Date(isoString);
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function fromDatetimeLocalValue(value) {
  if (!value) return new Date().toISOString();
  return new Date(value).toISOString();
}
